import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, TemplateRef, ViewEncapsulation, booleanAttribute, computed, contentChild, input } from '@angular/core';

export const Ds_Arrow_Size_ARRAY = ['small', 'medium', 'large'] as const;
export type DsArrowSize = (typeof Ds_Arrow_Size_ARRAY)[number];
export type DsArrowDirection = 'left' | 'right';
export const DS_Arrow_VARIANT_ARRAY = ['strong', 'subtle'] as const;
export type DsArrowVariant = (typeof DS_Arrow_VARIANT_ARRAY)[number];

@Component({
    selector: 'ds-arrow',
    imports: [CommonModule, NgTemplateOutlet],
    templateUrl: './arrow.component.html',
    host: {
        '[class]': 'hostClass()',
        '[class.ds-right-arrow]': "direction() === 'right'",
        '[class.ds-arrow-inverse]': 'inverse()',
        'tabIndex': '0',
        'role': 'button',
        '[attr.aria-label]': 'ariaLabel()',
    },
    styleUrl: './arrow.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsArrow {
    public readonly size = input<DsArrowSize>('large');
    public readonly direction = input<DsArrowDirection>('left');
    public readonly inverse = input(false, { transform: booleanAttribute });
    public readonly variant = input<DsArrowVariant>('strong');

    protected readonly dsArrowTpl = contentChild<TemplateRef<any>>('dsArrow');

    protected readonly ariaLabel = computed(() => (this.direction() === 'right' ? 'right arrow' : 'left arrow'));

    protected readonly hostClass = computed(() => {
        const sizeClass = `ds-arrow-${this.size()}`;
        const variantClass = `ds-arrow-${this.variant()}`;
        return `ds-arrow ${sizeClass} ${variantClass}`;
    });
}
